import styled from "styled-components";

export const MarketingPageRoot = styled.div`
  width: 100%;
  overflow-x: hidden;
  background: #ffffff;
  color: #1a1a1a;
`;
